
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/systems",
      function () {
        return require("private-next-pages/systems/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/systems"])
      });
    }
  